import { DateTime, DateTimeFormatOptions } from 'luxon';
import { IntlShape } from 'react-intl';

import { ShortCodeEnums } from '@nhl/nhl-breakaway-ui';

export const DAY_MONTH_DATE: DateTimeFormatOptions = { weekday: 'long', month: 'long', day: 'numeric' };

export const GAME_TIME: DateTimeFormatOptions = { hour: 'numeric', minute: 'numeric', timeZoneName: 'short' };

// ICE-1862: The Finnish "short month" spills over in the header widget so we only use the first 3 characters
// ICE-2168: Adding \n characters and using the css `white-space: pre` rule so that the strings will automatically
//           wrap where there would normally be spaces
export const getShortMonthDate = (date: DateTime, language: ShortCodeEnums.Language, newlineFlag = false): string => {
    if (language === ShortCodeEnums.Language.Finnish) {
        const day = date.toLocaleString({ day: 'numeric' });
        const month = date.toLocaleString({ month: 'short' });
        return newlineFlag ? `${day}\n${month.substring(0, 3)}.` : `${day} ${month.substring(0, 3)}.`;
    }

    const output = date.toLocaleString({ month: 'short', day: 'numeric' });
    return newlineFlag ? output.replaceAll(' ', '\n') : output;
};

export const getShortMonthFromDateString = (
    dateString: string,
    language: ShortCodeEnums.Language,
    newlineFlag = false
): string => {
    const date = DateTime.fromISO(dateString, { locale: language });
    return getShortMonthDate(date, language, newlineFlag);
};

export const getDateRangeStringForWeek = (start: DateTime, intl: IntlShape): string => {
    const end = start.plus({ days: 6 });
    const startDate = getShortMonthDate(start, intl.locale as ShortCodeEnums.Language);
    const endDate = start.hasSame(end, 'month')
        ? end.toLocaleString({ day: 'numeric' })
        : getShortMonthDate(end, intl.locale as ShortCodeEnums.Language);
    return intl.formatMessage(
        {
            description: 'The start and end date of a 7 day stretch. Ex. Jun 1 - 8',
            defaultMessage: '{startDate} - {endDate}',
        },
        { startDate, endDate }
    );
};
